import styled, { css } from 'styled-components';

import { Button as UnstyledButton } from 'features/common/components/Button';
import { Modal as UnstyledModal } from 'features/common/components/Modal';

export const Modal = styled(UnstyledModal)`
	display: flex;
	flex-direction: column;

	@media screen and (max-width: ${({ theme }) => theme.breakpoints.sm}) {
		width: 95vw;
	}
`;

export const Body = styled(UnstyledModal.Body)`
	padding: 24px;
	gap: 16px;
	overflow-y: auto;
	min-height: 0;
	flex: 1;

	@media screen and (max-width: ${({ theme }) => theme.breakpoints.sm}) {
		padding: 16px;
	}
`;

export const Description = styled.div`
	font-size: 14px;
	line-height: 1.4;
	color: #4b5563;
`;

export const HeaderChips = styled.div`
	margin-top: 8px;
	display: flex;
	flex-wrap: wrap;
	gap: 8px;
`;

export const Chip = styled.span`
	background-color: #f3f4f6;
	padding: 4px 8px;
	border-radius: 6px;
	font-size: 12px;
	color: #111827;
`;

export const Hint = styled.div`
	margin-top: 8px;
	font-size: 12px;
	color: #6b7280;

	strong {
		color: #374151;
	}
`;

export const DropZone = styled.div`
	margin-top: 16px;
	border-radius: 12px;
	border: 2px dashed #e5e7eb;
	background-color: #f9fafb;
	padding: 24px 48px;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	gap: 16px;
	cursor: pointer;
	transition: background-color 200ms ease;

	&:hover {
		background-color: #f3f4f6;
	}
`;

export const UploadIconCircle = styled.div`
	padding: 16px;
	background-color: #f3f4f6;
	border-radius: 9999px;
	display: flex;
	align-items: center;
	justify-content: center;
	color: #4b5563;
`;

export const DropZoneText = styled.p`
	color: #4b5563;
	text-align: center;
	font-size: 14px;
	margin: 0;

	strong {
		font-weight: 700;
	}
`;

export const HiddenInput = styled.input`
	display: none;
`;

export const FileBlock = styled.div`
	display: flex;
	flex-direction: column;
	gap: 16px;
`;

export const FileInfoRow = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: 12px;
	padding: 12px;
	background-color: #f9fafb;
	border-radius: 8px;
`;

export const FileMeta = styled.div`
	display: flex;
	align-items: center;
	gap: 12px;
	min-width: 0;
`;

export const FileTexts = styled.div`
	display: flex;
	flex-direction: column;
	min-width: 0;

	p {
		margin: 0;
		font-size: 14px;
	}
`;

export const FileName = styled.p`
	font-weight: 500;
	color: #111827;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
`;

export const FileSize = styled.p`
	color: #6b7280;
`;

export const RemoveFileBtn = styled.button`
	background: none;
	border: none;
	color: #6b7280;
	cursor: pointer;
	padding: 4px;
	border-radius: 4px;
	display: flex;
	align-items: center;

	&:hover {
		color: #111827;
		background-color: #f3f4f6;
	}
`;

export const ErrorBox = styled.div`
	padding: 12px;
	background-color: #fef2f2;
	border: 1px solid #fecaca;
	border-radius: 8px;

	p {
		margin: 0;
		font-size: 14px;
		color: #dc2626;
	}

	p + p {
		margin-top: 4px;
		font-size: 12px;
		color: #ef4444;
	}
`;

export const FieldGroup = styled.div`
	display: flex;
	flex-direction: column;
	gap: 8px;
`;

export const FieldLabel = styled.label`
	font-size: 14px;
	font-weight: 500;
	color: #374151;
`;

export const SelectInput = styled.select`
	width: 50%;
	padding: 8px 12px;
	border-radius: 8px;
	border: 1px solid #e5e7eb;
	background-color: #fff;
	font-size: 14px;
	color: #111827;
	cursor: pointer;

	&:focus {
		outline: none;
		border-color: #9ca3af;
	}

	@media screen and (max-width: ${({ theme }) => theme.breakpoints.sm}) {
		width: 100%;
	}
`;

export const PreviewHeaderRow = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: 8px;

	h3 {
		margin: 0;
		font-size: 14px;
		font-weight: 500;
		color: #111827;
	}

	p {
		margin: 0;
		font-size: 12px;
		color: #6b7280;
	}
`;

export const TableWrapper = styled.div`
	border: 1px solid #e5e7eb;
	border-radius: 8px;
	overflow: hidden;
	overflow-x: auto;
`;

export const PreviewTable = styled.table`
	table-layout: fixed;
	width: 100%;
	border-collapse: collapse;
`;

export const HeaderCell = styled.th<{ width: string; minWidth: string }>`
	${({ width, minWidth }) => css`
		width: ${width};
		min-width: ${minWidth};
	`}
	padding: 12px;
	border-bottom: 1px solid #e5e7eb;
	background-color: #f9fafb;
	transition: background-color 300ms ease, border-color 300ms ease;
	text-align: left;
`;

export const HeaderInner = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
`;

export const HeaderLabel = styled.span`
	font-size: 14px;
	font-weight: 500;
	color: #111827;
	line-height: 1;
`;

export const ArrowsWrapper = styled.div`
	display: flex;
	gap: 4px;
`;

export const ArrowButton = styled.button`
	background: none;
	border: none;
	padding: 4px;
	border-radius: 4px;
	cursor: pointer;
	color: #4b5563;
	display: flex;
	align-items: center;
	justify-content: center;

	&:hover:not(:disabled) {
		background-color: #f3f4f6;
	}

	&:disabled {
		opacity: 0.3;
		cursor: not-allowed;
	}
`;

export const DataCell = styled.td`
	padding: 10px 12px;
	font-size: 14px;
	color: #111827;
	border-bottom: 1px solid #f3f4f6;
	overflow: hidden;
	max-height: 40px;
	line-height: 1.25;
	word-break: break-word;

	div {
		display: -webkit-box;
		-webkit-line-clamp: 2;
		-webkit-box-orient: vertical;
		overflow: hidden;
	}
`;

export const TruncatedNote = styled.p`
	margin: 0;
	font-size: 12px;
	color: #6b7280;
	text-align: center;
`;

export const ActionsRow = styled.div`
	display: flex;
	justify-content: flex-end;
	gap: 12px;
	flex-wrap: wrap;
`;

export const ModalButton = styled(UnstyledButton)`
	&& {
		width: auto;
		margin: 0;
		font-size: 14px;
		font-weight: 500;
		height: 40px;
		padding: 0 18px;
		min-width: 120px;
		display: inline-flex;
		align-items: center;
		justify-content: center;
		gap: 8px;
		flex: 0 0 auto;
	}
`;

export const Spinner = styled.div`
	width: 14px;
	height: 14px;
	border: 2px solid currentColor;
	border-top-color: transparent;
	border-radius: 50%;
	animation: spin 800ms linear infinite;

	@keyframes spin {
		to {
			transform: rotate(360deg);
		}
	}
`;
